import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    nav: {
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      title: 'ELD to Rely On',
      subtitle: 'Reliable FMCSA-certified Electronic Logbook services tailored to your business needs',
      getInTouch: 'Get in Touch'
    },
    services: {
      personalizedTraining: {
        title: 'Personalized Driver Training',
        features: {
          0: 'Tailored training based on driver experience',
          1: 'Step-by-step guidance',
          2: 'Common mistake prevention'
        }
      },
      videoGuides: {
        title: 'Video Setup Guides',
        features: {
          0: 'Detailed device installation steps',
          1: 'Indicator light explanations',
          2: 'Proper activation walkthrough'
        }
      },
      dedicatedSupport: {
        title: '24/7 Dedicated Support',
        features: {
          0: 'Personal account managers',
          1: 'Continuous assistance without downtime'
        }
      },
      realTimeMonitoring: {
        title: 'Real-Time Monitoring',
        features: {
          0: '24/7 driver activity tracking',
          1: 'Violation detection and alerts'
        }
      },
      expertConsulting: {
        title: 'Expert ELD Consulting',
        features: {
          0: 'Driver Q&A support',
          1: 'Assistance in non-standard situations'
        }
      },
      technicalSupport: {
        title: 'Technical Support (24/7)',
        features: {
          0: 'Quick troubleshooting',
          1: 'Updates and error resolution',
          2: 'Contact via phone, email, messenger'
        }
      },
      iftaReports: {
        title: 'IFTA Report Handling',
        features: {
          0: 'Accurate quarterly submissions',
          1: 'Per-truck cost calculations',
          2: 'Full DOT compliance'
        }
      },
      documentStorage: {
        title: 'Document Storage for Inspections',
        features: {
          0: 'Secure document retention',
          1: 'Audit-ready organization',
          2: 'Easy access to required records'
        }
      },
      customizedSupport: {
        title: 'Customized Support',
        features: {
          0: 'Flexible processes and schedules',
          1: 'Personalized communication',
          2: 'Attention to operational details'
        }
      },
      onSiteSetup: {
        title: 'On-site Setup in Chicago',
        features: {
          0: 'Local truck onboarding',
          1: 'In-person demonstrations',
          2: 'Driver training with practice'
        }
      }
    }
  },
  ru: {
    nav: {
      services: 'Услуги',
      contact: 'Контакты'
    },
    hero: {
      title: 'ELD, на который можно положиться',
      subtitle: 'Наша компания будет рада предоставить Вам качественный ELD сервис и создать наилучшие условия для развития Вашего бизнеса',
      getInTouch: 'Связаться с нами'
    },
    services: {
      personalizedTraining: {
        title: 'Индивидуальное обучение водителя',
        features: {
          0: 'Персональный подход в зависимости от уровня знаний водителя',
          1: 'Пошаговое объяснение, как правильно вести логбук',
          2: 'Разбор типичных ошибок и советы по их предотвращению'
        }
      },
      videoGuides: {
        title: 'Видеоинструктаж по подключению ELD Box',
        features: {
          0: 'Подробное руководство по установке и активации устройства',
          1: 'Объяснение световых индикаторов и проверка корректной работы',
          2: 'Пошаговая инструкция по правильной активации'
        }
      },
      dedicatedSupport: {
        title: 'Индивидуальная команда поддержки 24/7',
        features: {
          0: 'Персональные менеджеры, которые ведут вашего водителя',
          1: 'Помощь и сопровождение без выходных и перерывов'
        }
      },
      realTimeMonitoring: {
        title: 'Круглосуточный мониторинг водителя',
        features: {
          0: 'Отслеживание активности 24/7',
          1: 'Проверка и предотвращение нарушений (violations) в логбуке'
        }
      },
      expertConsulting: {
        title: 'Консультации по всем вопросам ELD',
        features: {
          0: 'Ответы на любые вопросы водителя',
          1: 'Помощь в нестандартных ситуациях и разъяснение правил'
        }
      },
      technicalSupport: {
        title: 'Техническая поддержка 24/7',
        features: {
          0: 'Быстрое решение технических проблем',
          1: 'Настройка, обновления, устранение ошибок и сбоев в работе ELD',
          2: 'Связь в любое время — по телефону, мессенджеру или email'
        }
      },
      iftaReports: {
        title: 'Предоставление IFTA-отчётности',
        features: {
          0: 'Своевременная подача отчетов каждый квартал',
          1: 'Расчёт по каждому траку индивидуально',
          2: 'Гарантия точности и соответствия требованиям DOT'
        }
      },
      documentStorage: {
        title: 'Сохранение документов инспекции',
        features: {
          0: 'Надёжное хранение всех ваших документов по инспекциям',
          1: 'Упорядочение и подготовка документов для возможных проверок и аудитa',
          2: 'Обеспечение удобства и правильности подачи всей необходимой информации'
        }
      },
      customizedSupport: {
        title: 'Индивидуальная работа с каждой компанией',
        features: {
          0: 'Учитываем все ваши пожелания и особенности бизнеса',
          1: 'Гибкий подход к процессам, графикам и коммуникации',
          2: 'Максимальное удобство и внимание к каждой детали вашей работы'
        }
      },
      onSiteSetup: {
        title: 'Возможность подключения траков в Чикаго',
        features: {
          0: 'Удобное подключение ваших траков прямо на месте',
          1: 'Личная демонстрация, как правильно пользоваться логбуком',
          2: 'Индивидуальное обучение водителя на месте — с практикой и объяснением всех нюансов'
        }
      }
    }
  },
  uk: {
    nav: {
      services: 'Послуги',
      contact: 'Контакти'
    },
    hero: {
      title: 'ELD, на який можна покластися',
      subtitle: 'Наша компанія буде рада надати Вам якісний ELD сервіс та створити найкращі умови для розвитку Вашого бізнесу',
      getInTouch: 'Зв\'язатися з нами'
    },
    services: {
      personalizedTraining: {
        title: 'Індивідуальне навчання водія',
        features: {
          0: 'Персональний підхід залежно від рівня знань водія',
          1: 'Покрокове пояснення, як правильно вести логбук',
          2: 'Розбір типових помилок та поради щодо їх запобігання'
        }
      },
      videoGuides: {
        title: 'Відеоінструктаж з підключення ELD Box',
        features: {
          0: 'Детальний посібник з встановлення та активації пристрою',
          1: 'Пояснення світлових індикаторів та перевірка коректної роботи',
          2: 'Покрокова інструкція з правильної активації'
        }
      },
      dedicatedSupport: {
        title: 'Індивідуальна команда підтримки 24/7',
        features: {
          0: 'Персональні менеджери, які ведуть вашого водія',
          1: 'Допомога та супровід без вихідних та перерв'
        }
      },
      realTimeMonitoring: {
        title: 'Цілодобовий моніторинг водія',
        features: {
          0: 'Відстеження активності 24/7',
          1: 'Перевірка та запобігання порушенням (violations) у логбуку'
        }
      },
      expertConsulting: {
        title: 'Консультації з усіх питань ELD',
        features: {
          0: 'Відповіді на будь-які питання водія',
          1: 'Допомога в нестандартних ситуаціях та роз\'яснення правил'
        }
      },
      technicalSupport: {
        title: 'Технічна підтримка 24/7',
        features: {
          0: 'Швидке вирішення технічних проблем',
          1: 'Налаштування, оновлення, усунення помилок та збоїв у роботі ELD',
          2: 'Зв\'язок у будь-який час — по телефону, месенджеру або email'
        }
      },
      iftaReports: {
        title: 'Надання IFTA-звітності',
        features: {
          0: 'Своєчасна подача звітів кожен квартал',
          1: 'Розрахунок по кожному траку індивідуально',
          2: 'Гарантія точності та відповідності вимогам DOT'
        }
      },
      documentStorage: {
        title: 'Зберігання документів інспекції',
        features: {
          0: 'Надійне зберігання всіх ваших документів по інспекціям',
          1: 'Упорядкування та підготовка документів для можливих перевірок та аудиту',
          2: 'Забезпечення зручності та правильності подання всієї необхідної інформації'
        }
      },
      customizedSupport: {
        title: 'Індивідуальна робота з кожною компанією',
        features: {
          0: 'Враховуємо всі ваші побажання та особливості бізнесу',
          1: 'Гнучкий підхід до процесів, графіків та комунікації',
          2: 'Максимальна зручність та увага до кожної деталі вашої роботи'
        }
      },
      onSiteSetup: {
        title: 'Можливість підключення траків у Чикаго',
        features: {
          0: 'Зручне підключення ваших траків прямо на місці',
          1: 'Особиста демонстрація, як правильно користуватися логбуком',
          2: 'Індивідуальне навчання водія на місці — з практикою та поясненням усіх нюансів'
        }
      }
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n 